import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { Usuario } from 'src/app/shared/models/usuario.model';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService extends BaseService<Usuario>{

  constructor(public http: HttpClient) {
    super(http)
  }

  public getPathModule(): string {
    return '/usuarios';
  }
}
